<div class="header_main" [class.scrolled]="isScrolled" [class.nav-open]="isMenuOpen">
    <div class="mobile-menu-backdrop" [class.show]="isMenuOpen" (click)="closeNavbar()"></div>
    <div class="header_top">
        <!-- <p>Download LegalStack Mobile App</p>
        <div class="image_div">
            <img src="/assets/icons/header/ios_img.svg" alt="">
            <img src="/assets/icons/header/android_img.svg" alt="">
        </div> -->

        <div class="marquee">
            <p>"Your trusted partner for business success and peace of mind."</p>
        </div>

    </div>

    <div class="header_bottom">
        <nav class="navbar navbar-expand-lg headMainNav">
            <div class="container">
                <div class="header_left">
                    <button class="navbar-toggler hamburger-btn" type="button" aria-label="Toggle navigation"
                        (click)="toggleNavbar()">
                        <span class="hamburger-lines" aria-hidden="true">
                            <span></span>
                            <span></span>
                            <span></span>
                        </span>
                    </button>

                    <a class="navbar-brand" routerLink="/">
                        <img src="/assets/icons/header/legalStack.svg" alt="" class="img-fluid">
                    </a>


                    <div class="header_dropdown">
                        <div class="header_dropdown_item1">
                            <button type="button" class="product_dropdown">Business
                                <span class=" px-2">
                                    <svg width="10" class="rotate-180 " height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z"
                                            fill="#596C85"></path>
                                    </svg>
                                </span>
                            </button>
                            <div class="dropdown_item">
                                <div class="item_list">
                                    <div class="menu">
                                        <h6 class="title">Company Registration</h6>
                                        <a routerLink="/products/startup/Private-limited-company" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/pvtLimited.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Private Limited Company
                                                </div>

                                            </div>
                                        </a>
                                        <a routerLink="/products/startup/Limited-Liability-Partnership" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/llp.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Limited Liability Partnership (LLP)
                                                </div>
                                            </div>
                                        </a>
                                        <a routerLink="/products/startup/One-person-company" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/individual.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    One Person Company</div>

                                            </div>
                                        </a>
                                        <a routerLink="/products/startup/Sole-Proprietorship" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/individual.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Sole Proprietorship</div>

                                            </div>
                                        </a>

                                        <a routerLink="/products/startup/Partnership-Firm-Registration" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/partnership.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Partnership Firm Registration</div>

                                            </div>
                                        </a>


                                    </div>
                                    <div class="menu">
                                        <h6 class="title">Agreements</h6>
                                        <a routerLink="/products/agreement/Rent-Agreement" class="group group_2">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/rental.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Rent Agreement</div>
                                                <p class="sub_text">
                                                    Place the order and get your rent agreements</p>
                                            </div>
                                        </a>


                                    </div>
                                    <div class="menu">
                                        <h6 class="title">CONSUMER PRODUCTS</h6>
                                        <a routerLink="/products/tax-and-compliance" class="group ">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/itr.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    ITR Filing</div>

                                            </div>
                                        </a>
                                        <a routerLink="/products/gst-filing" class="group ">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/gst-filing.png" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    GST Filing
                                                </div>
                                            </div>
                                        </a>
                                        <!-- <a routerLink="/talk-to-advisor" class="group group_2">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/consultant.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Tax Consultant Services</div>
                                                <p class="sub_text">For
                                                    Personal Tax and business compliances</p>
                                            </div>
                                        </a> -->
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="header_dropdown_item2">
                            <button type="button" class="resources_dropdown">Compliances
                                <span class=" px-2">
                                    <svg width="10" class="rotate-180 " height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z"
                                            fill="#596C85"></path>
                                    </svg>
                                </span>
                            </button>
                            <div class="dropdown_item2">
                                <div class="item_list">
                                    <div class="menu">
                                        <h6 class="title">
                                            Compliances & Registration</h6>
                                        <a routerLink="/products/startup/GST-Registration" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/gst.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    GST Registration</div>
                                            </div>
                                        </a>
                                        <a routerLink="/products/startup/MSME-Registration" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/msme_5.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    MSME Registration</div>
                                            </div>
                                        </a>
                                        <a routerLink="/products/human-resource/PF-Provident-Fund" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/pf_2.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Provident Fund (PF) Registration</div>
                                            </div>
                                        </a>

                                        <a routerLink="/products/human-resource/ESIC" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/esic.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    ESIC Registration</div>
                                            </div>
                                        </a>

                                        <a routerLink="/products/human-resource/TDS-Filling" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/tds_1.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    TDS Filling</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="header_dropdown_item3">
                            <button type="button" class="company_dropdown">Company
                                <span class=" px-2">
                                    <svg width="10" class="rotate-180 " height="6" viewBox="0 0 10 6" fill="none"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M0.83712 5.5028C1.16307 5.82646 1.68939 5.82553 2.0142 5.50072L5.24336 2.27156L8.48054 5.50169C8.80529 5.82573 9.33115 5.82544 9.65554 5.50104C9.98019 5.1764 9.98019 4.65005 9.65554 4.3254L5.83262 0.502481C5.50718 0.177044 4.97954 0.177044 4.65411 0.502481L0.835034 4.32155C0.508602 4.64799 0.509537 5.17752 0.83712 5.5028Z"
                                            fill="#596C85"></path>
                                    </svg>
                                </span>
                            </button>
                            <div class="dropdown_item3">
                                <div class="item_list">
                                    <div class="menu">
                                        <a routerLink="/about-us" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/about.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    About Us</div>
                                            </div>
                                        </a>
                                        <a routerLink="/contact-us" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/contact.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Contact Us</div>
                                            </div>
                                        </a>
                                        <a routerLink="/press-and-media" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/press.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Media &amp; Press</div>
                                            </div>
                                        </a>
                                        <a routerLink="/terms" class="group">
                                            <div class="image">
                                                <img src="/assets/icons/dropdown_icons/trust.svg" alt="">
                                            </div>
                                            <div class="content">
                                                <div class="text">
                                                    Trust and Safety</div>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>

                <div class="header_right">
                    <div class="chat-call-btn">
                        <a class="img_btns" routerLink="/talk-to-advisor"><img src="assets/icons/header/phone-call.png"
                                alt=""></a>
                    </div>
                    <img src="/assets/icons/header/search_icon.svg" alt="" class="search_img">

                    <span class="user_profile">
                        <div class="profile_box" *ngIf="gS.isUserLoggedin">
                            <a class="accounts" routerLink="userdetailPage"> My Account</a>
                            <a class="accounts_img" routerLink="userdetailPage"><img
                                    src="/assets/icons/header/accounts.png"></a>
                            <img src="/assets/icons/header/down_arrow.svg" class="blackArrow_new">
                        </div>
                    </span>

                    <li class="list-item usericon" *ngIf="!gS.isUserLoggedin">
                        <a class="btns" (click)="openLoginPopup('login')">
                            <span class="login_btn">Login</span>
                        </a>
                    </li>

                </div>

                <div class="ml-4 pr-0 navbar-collapse" id="navbarSupportedContent" *ngIf="gS.isUserLoggedin"
                    [ngClass]="{'menu-open': isMenuOpen}">

                    <div class="chat-call-btn">
                        <a class="btns" routerLink="/talk-to-advisor"><span class="chat_btn">Talk to Advisor</span></a>
                    </div>
                    <div class="mobSrchView">
                        <div class="headerDiv">
                            <div class="headerDiv_left">
                                <button type="button" (click)="closeNavbar()" class="navbar-toggler navClose">
                                    <img src="/assets/icons/header/toggel_menu.svg" alt="">
                                </button>
                                <img src="/assets/icons/header/legalStack.svg" alt="" class="logo_img">
                            </div>
                        </div>
                        <div class="optionDivMain">
                            <div class="withLogin optionDivMain_2">
                                <div class="optionDiv">
                                    <div id="accordionExample" class="accordion">
                                        <div class="accordion-item-loop">
                                            <div class="accordion-item profile_item">
                                                <h2 id="headingLogin" class="accordion-header">
                                                    <button type="button" data-bs-toggle="collapse"
                                                        data-bs-target="#collapseLogin" aria-expanded="false"
                                                        aria-controls="collapseLogin"
                                                        class="accordion-button collapsed">
                                                        <div class="profileDesc">
                                                            <!-- <div class="profileImage">
                                                                <img class="profileImage"
                                                                    [src]="gS.userData?.profilePic || '/assets/user-icon.png'"
                                                                    alt="Profile Image"></div> -->
                                                            <div class="profileName"><span
                                                                    class="name first">{{gS.userName}}</span>
                                                            </div>
                                                        </div>
                                                    </button>
                                                </h2>
                                                <div id="collapseLogin" aria-labelledby="headingLogin"
                                                    data-bs-parent="#accordionExample"
                                                    class="accordion-collapse collapse">
                                                    <div class="accordion-body">
                                                        <ul class="menu">
                                                            <li><a routerLink="/userdetailPage"
                                                                    (click)="closeNavbar()">My Profile</a></li>
                                                            <li><a routerLink="/recharge-wallet"
                                                                    (click)="closeNavbar()">Wallet Balence
                                                                    <span class="wallet_amount">₹ 773</span></a></li>
                                                            <li><a routerLink="/customer-product-order-history"
                                                                    (click)="closeNavbar()">My
                                                                    Orders</a>
                                                            </li>
                                                            <li><a routerLink="/support-chat"
                                                                    (click)="closeNavbar()">Customer Support Chat</a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="option_div">
                                            <!-- <div class="menu_item" *ngFor="let item of menuList">
                                                <li data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                                                    class="" *ngIf="item?.isActive">
                                                    <a [routerLink]="item?.redirectUrl" class="d-flex active">
                                                        <div class="menu">{{item?.name}}</div>
                                                    </a>
                                                </li>

                                            </div> -->
                                            <div class="accordion accordion-flush" id="accordionFlushExample">
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#flush-collapseOne" aria-expanded="false"
                                                            aria-controls="flush-collapseOne">
                                                            Business
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapseOne" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <div class="item_list">
                                                                <div class="menu">
                                                                    <h6 class="title">Company Registration</h6>
                                                                    <a class="group"
                                                                        routerLink="/products/startup/Private-limited-company"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/pvtLimited.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Private Limited Company</div>

                                                                        </div>
                                                                    </a>
                                                                    <a class="group"
                                                                        routerLink="/products/startup/Limited-Liability-Partnership"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/llp.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Limited Liability Partnership (LLP)
                                                                            </div>

                                                                        </div>
                                                                    </a>
                                                                    <a class="group"
                                                                        routerLink="/products/startup/One-person-company"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/individual.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                One Person Company</div>

                                                                        </div>
                                                                    </a>

                                                                    <a routerLink="/products/startup/Sole-Proprietorship"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/individual.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Sole Proprietorship</div>
                                                                        </div>
                                                                    </a>

                                                                    <a class="group"
                                                                        routerLink="/products/startup/Partnership-Firm-Registration"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/partnership.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Partnership Firm Registration</div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                                <div class="menu">
                                                                    <h6 class="title">Agreements</h6>
                                                                    <a routerLink="/products/agreement/Rent-Agreement"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/rental.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text"> Rent Agreement</div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                                <div class="menu">
                                                                    <h6 class="title">CONSUMER PRODUCTS</h6>
                                                                    <a routerLink="/products/tax-and-compliance"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/itr.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                ITR Filing</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/talk-to-advisor" class="group"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/consultant.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Tax Consultant Services</div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#flush-collapseTwo" aria-expanded="false"
                                                            aria-controls="flush-collapseTwo">
                                                            Compliances
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapseTwo" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <div class="item_list">
                                                                <div class="menu">
                                                                    <h6 class="title">Compliances & Registration
                                                                    </h6>
                                                                    <a routerLink="/products/startup/GST-Registration"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/gst.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text"> GST Registration</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/products/startup/MSME-Registration"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/msme_5.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                MSME Registration</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/products/human-resource/PF-Provident-Fund"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/pf_2.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Provident Fund (PF) Registration</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/products/human-resource/ESIC"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/esic.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                ESIC Registration</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/products/human-resource/TDS-Filling"
                                                                        class="group" (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/tds_1.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                TDS Filling</div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="accordion-item">
                                                    <h2 class="accordion-header">
                                                        <button class="accordion-button collapsed" type="button"
                                                            data-bs-toggle="collapse"
                                                            data-bs-target="#flush-collapseThree" aria-expanded="false"
                                                            aria-controls="flush-collapseThree">
                                                            Company
                                                        </button>
                                                    </h2>
                                                    <div id="flush-collapseThree" class="accordion-collapse collapse"
                                                        data-bs-parent="#accordionFlushExample">
                                                        <div class="accordion-body">
                                                            <div class="item_list other_item_list">
                                                                <div class="menu">
                                                                    <a routerLink="/about-us" class="group"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/about.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                About Us</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/contact-us" class="group"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/contact.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Contact Us</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/press-and-media" class="group"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/press.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Media &amp; Press</div>
                                                                        </div>
                                                                    </a>
                                                                    <a routerLink="/terms" class="group"
                                                                        (click)="closeNavbar()">
                                                                        <div class="image">
                                                                            <img src="/assets/icons/dropdown_icons/trust.svg"
                                                                                alt="">
                                                                        </div>
                                                                        <div class="content">
                                                                            <div class="text">
                                                                                Trust and Safety</div>
                                                                        </div>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>




                                        <div routerlink="/logout" class="signOutDiv" tabindex="0"
                                            (click)="gS.LogoutUser()">
                                            <img src="/assets/icons/header/sign_out.svg" alt="">
                                            <a href="">Sign Out</a>
                                        </div>

                                        <div class="drawer-social">
                                            <p class="ds-label">Connect with us</p>
                                            <div class="ds-icons">
                                                <a href="https://www.facebook.com/" target="_blank" rel="noopener" aria-label="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
                                                <a href="https://www.instagram.com/" target="_blank" rel="noopener" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
                                                <a href="https://www.linkedin.com/" target="_blank" rel="noopener" aria-label="LinkedIn"><i class="fa-brands fa-linkedin-in"></i></a>
                                                <a href="https://twitter.com/" target="_blank" rel="noopener" aria-label="X"><i class="fa-brands fa-x-twitter"></i></a>
                                                <a href="https://www.youtube.com/" target="_blank" rel="noopener" aria-label="YouTube"><i class="fa-brands fa-youtube"></i></a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="d-flex align-self-center justify-content-between" style="display: none !important;">
                            <div class="srchLeft col-6">
                                <button type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
                                    aria-controls="navbarSupportedContent" aria-expanded="true"
                                    aria-label="Toggle navigation" class="navbar-toggler navClose">
                                    <span>X</span>
                                </button>
                                <img src="../../assets/images/logo.svg" width="75" alt="">
                            </div>
                            <div id="headSearchShell" class="collapse navbar-collapse">
                                <div class="d-flex align-self-center justify-content-center">
                                    <button type="button" data-bs-toggle="collapse" data-bs-target="#headSearchShell"
                                        aria-controls="headSearchShell" aria-expanded="false"
                                        aria-label="Toggle navigation" class="navbar-toggler">
                                        <img src="../../assets/images/srchArrow.svg" width="20" alt="">
                                    </button>
                                    <div class="inputSrch position-relative">
                                        <input type="text" value="">
                                        <img src="../../assets/images/srch-icon.svg" width="17" alt=""
                                            class="inputLens">
                                        <img src="../../assets/images/close-btn.svg" width="17" alt=""
                                            class="inputClose">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ul class="navbar-new">
                        <li>
                            <div class="vl"></div>
                        </li>
                    </ul>

                    <span class="user_profile_deskView">
                        <div class="profile_box" *ngIf="gS.isUserLoggedin">
                            <!-- <div class="profileImageSec">
                                <img class="profileImage"
                                    [src]="gS.userData?.profilePic || '/assets/user-icon.png'"
                                    alt="Profile Image" (click)="gS.navigate('userdetailPage')">

                            </div> -->
                            <div class="profileInfoSec">
                                <!-- <p class="second">
                                   
                                    {{ gS.userName.length > 4 ? (gS.userName | slice:0:4) + '...' : gS.userName }}
                                </p> -->

                                <ul class="multilevel-dropdown-menu">

                                    <li class="parent parent_main">
                                        <span class="down">
                                            <span class="account-avatar">{{ (gS.userName || 'U') | slice:0:1 }}</span>
                                            <p class="second">
                                                My Account
                                            </p>
                                            <i class="fa-solid fa-chevron-down"></i>
                                        </span>
                                        <ul class="child account-child">

                                            <li class="account-head">
                                                <span class="account-avatar lg">{{ (gS.userName || 'U') | slice:0:1 }}</span>
                                                <span class="account-head-info">
                                                    <span class="account-head-name">{{ gS.userName || 'User' }}</span>
                                                    <span class="account-head-sub">Manage your account</span>
                                                </span>
                                            </li>

                                            <li>
                                                <a routerLink="/dashboard">
                                                    <span class="ico"><i class="fa-solid fa-table-columns"></i></span>
                                                    <span class="txt">Dashboard</span>
                                                    <i class="fa-solid fa-chevron-right chev"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a routerLink="/userdetailPage">
                                                    <span class="ico"><i class="fa-regular fa-user"></i></span>
                                                    <span class="txt">My Profile</span>
                                                    <i class="fa-solid fa-chevron-right chev"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" (click)="gS.navigate('recharge-wallet')">
                                                    <span class="ico"><i class="fa-solid fa-wallet"></i></span>
                                                    <span class="txt">Wallet Balance</span>
                                                    <span class="wallet_amount">₹ {{gS.userBalance}}</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="javascript:void(0)" (click)="gS.navigate('customer-product-order-history')">
                                                    <span class="ico"><i class="fa-solid fa-box-open"></i></span>
                                                    <span class="txt">My Orders</span>
                                                    <i class="fa-solid fa-chevron-right chev"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a routerLink="/support-chat">
                                                    <span class="ico"><i class="fa-regular fa-comments"></i></span>
                                                    <span class="txt">Customer Support</span>
                                                    <i class="fa-solid fa-chevron-right chev"></i>
                                                </a>
                                            </li>
                                            <li class="account-signout">
                                                <a routerLink="#" (click)="gS.LogoutUser()">
                                                    <span class="ico"><i class="fa-solid fa-right-from-bracket"></i></span>
                                                    <span class="txt">Sign Out</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </div>

                            <!-- <div class="logoutbtn" >
                                <button>SignOut</button>
                            </div> -->

                        </div>
                    </span>
                </div>

                <div class="ml-4 pr-0 navbar-collapse" id="navbarSupportedContent" *ngIf="!gS.isUserLoggedin"
                    [ngClass]="{'menu-open': isMenuOpen}">
                    <div class="chat-call-btn">
                        <a class="btns" routerLink="/talk-to-advisor"><span class="chat_btn">Talk to Advisor</span></a>
                    </div>

                    <div class="mobSrchView">
                        <div class="headerDiv">
                            <div class="headerDiv_left">
                                <button type="button" (click)="closeNavbar()" class="navbar-toggler navClose">
                                    <img src="/assets/icons/header/toggel_menu.svg" alt=""></button><img
                                    src="/assets/icons/header/legalStack.svg" alt="" class="logo_img">
                            </div>
                        </div>
                        <div class="optionDivMain">
                            <div class="withLogin optionDivMain_2">
                                <div class="optionDiv">
                                    <ul class="flat-menu">
                                        <li>
                                            <a routerLink="/" (click)="closeNavbar()">
                                                <i class="fa-solid fa-house"></i> Home
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/talk-to-advisor" (click)="closeNavbar()">
                                                <i class="fa-solid fa-headset"></i> Talk to Advisor
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/my-offers" (click)="closeNavbar()">
                                                <i class="fa-solid fa-tags"></i> Offers
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/about-us" (click)="closeNavbar()">
                                                <i class="fa-solid fa-circle-info"></i> About Us
                                            </a>
                                        </li>
                                        <li>
                                            <a routerLink="/contact-us" (click)="closeNavbar()">
                                                <i class="fa-solid fa-envelope"></i> Contact Us
                                            </a>
                                        </li>
                                    </ul>
                                    <div class="mobileView_dropdowns">
                                        <div class="accordion accordion-flush" id="accordionFlushExample">
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#flush-collapseOne"
                                                        aria-expanded="false" aria-controls="flush-collapseOne">
                                                        Business
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseOne" class="accordion-collapse collapse"
                                                    data-bs-parent="#accordionFlushExample">
                                                    <div class="accordion-body">
                                                        <div class="item_list">
                                                            <div class="menu">
                                                                <h6 class="title">Company Registration</h6>
                                                                <a class="group"
                                                                    routerLink="/products/startup/Private-limited-company"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/pvtLimited.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Private Limited Company</div>

                                                                    </div>
                                                                </a>
                                                                <a class="group"
                                                                    routerLink="/products/startup/Limited-Liability-Partnership"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/llp.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Limited Liability Partnership (LLP)
                                                                        </div>

                                                                    </div>
                                                                </a>
                                                                <a class="group"
                                                                    routerLink="/products/startup/One-person-company"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/individual.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            One Person Company</div>

                                                                    </div>
                                                                </a>
                                                                <a routerLink="/products/startup/Sole-Proprietorship"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/individual.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Sole Proprietorship</div>
                                                                    </div>
                                                                </a>
                                                                <a class="group"
                                                                    routerLink="/products/startup/Partnership-Firm-Registration"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/partnership.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Partnership Firm Registration</div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="menu">
                                                                <h6 class="title">Agreements</h6>
                                                                <a routerLink="/products/agreement/Rent-Agreement"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/rental.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text"> Rent Agreement</div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                            <div class="menu">
                                                                <h6 class="title">CONSUMER PRODUCTS</h6>
                                                                <a routerLink="/products/tax-and-compliance"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/itr.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            ITR Filing</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/talk-to-advisor" class="group"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/consultant.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Tax Consultant Services</div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#flush-collapseTwo"
                                                        aria-expanded="false" aria-controls="flush-collapseTwo">
                                                        Compliances
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseTwo" class="accordion-collapse collapse"
                                                    data-bs-parent="#accordionFlushExample">
                                                    <div class="accordion-body">
                                                        <div class="item_list">
                                                            <div class="menu">
                                                                <h6 class="title">Compliances & Registration
                                                                </h6>
                                                                <a routerLink="/products/startup/GST-Registration"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/gst.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text"> GST Registration</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/products/startup/MSME-Registration"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/msme_5.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            MSME Registration</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/products/human-resource/PF-Provident-Fund"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/pf_2.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Provident Fund (PF) Registration</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/products/human-resource/ESIC"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/esic.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            ESIC Registration</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/products/human-resource/TDS-Filling"
                                                                    class="group" (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/tds_1.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            TDS Filling</div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="accordion-item">
                                                <h2 class="accordion-header">
                                                    <button class="accordion-button collapsed" type="button"
                                                        data-bs-toggle="collapse" data-bs-target="#flush-collapseThree"
                                                        aria-expanded="false" aria-controls="flush-collapseThree">
                                                        Company
                                                    </button>
                                                </h2>
                                                <div id="flush-collapseThree" class="accordion-collapse collapse"
                                                    data-bs-parent="#accordionFlushExample">
                                                    <div class="accordion-body">
                                                        <div class="item_list other_item_list">
                                                            <div class="menu">
                                                                <a routerLink="/about-us" class="group"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/about.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            About Us</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/contact-us" class="group"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/contact.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Contact Us</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/press-and-media" class="group"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/press.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Media &amp; Press</div>
                                                                    </div>
                                                                </a>
                                                                <a routerLink="/terms" class="group"
                                                                    (click)="closeNavbar()">
                                                                    <div class="image">
                                                                        <img src="/assets/icons/dropdown_icons/trust.svg"
                                                                            alt="">
                                                                    </div>
                                                                    <div class="content">
                                                                        <div class="text">
                                                                            Trust and Safety</div>
                                                                    </div>
                                                                </a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="loginBtnDiv">
                                    <button class="loginBtn_new" (click)="openLoginPopup('login')">
                                        <i class="fa-solid fa-right-to-bracket"></i> <span>Log in</span>
                                    </button>
                                </div>

                                <div class="drawer-social">
                                    <p class="ds-label">Connect with us</p>
                                    <div class="ds-icons">
                                        <a href="https://www.facebook.com/" target="_blank" rel="noopener" aria-label="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
                                        <a href="https://www.instagram.com/" target="_blank" rel="noopener" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
                                        <a href="https://www.linkedin.com/" target="_blank" rel="noopener" aria-label="LinkedIn"><i class="fa-brands fa-linkedin-in"></i></a>
                                        <a href="https://twitter.com/" target="_blank" rel="noopener" aria-label="X"><i class="fa-brands fa-x-twitter"></i></a>
                                        <a href="https://www.youtube.com/" target="_blank" rel="noopener" aria-label="YouTube"><i class="fa-brands fa-youtube"></i></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="navbar-new">
                        <div class="vl"></div>
                    </div>

                    <ul class="navbar-new">

                        <li class="list-item usericon" *ngIf="!gS.isUserLoggedin">
                            <a class="btns" href="javascript:void(0)" (click)="openLoginPopup('login')"><span
                                    class="login_btn">Login</span></a>
                        </li>
                    </ul>

                    <span class="user_profile_deskView">
                        <div class="profile_box" *ngIf="gS.isUserLoggedin">
                            <!-- <div class="profileImageSec">
                                <img class="profileImage" [src]="gS.userData?.profilePic || '/assets/user-icon.png'"
                                    alt="Profile Image">
                                <img src="/assets/icons/header/green_dot.svg" class="online_img">
                            </div> -->
                            <!-- {{ gS.userName.length > 5 ? (gS.userName | slice:0:5) + '...' :
                            gS.userName }} -->
                            <a routerLink="userdetailPage"> My Account</a>
                            <a routerLink="userdetailPage">
                                <img src="/assets/icons/header/accounts.png" class="accounts">
                            </a>
                            <img src="/assets/icons/header/down_arrow.svg" class="blackArrow_new">
                        </div>
                    </span>
                </div>
            </div>
            <div class="divider"></div>
            <!-- <div class="d-flex other_opt container">
                <a *ngFor="let item of productCategory | slice:0:5"
                    routerLink="/products/{{item?.pageUrl}}">{{item?.categoryName}}</a>
                <ul class="multilevel-dropdown-menu" *ngIf="productCategory.length>5">
                    <li class="parent parent_main">More<span class="down"><i
                                class="fa-solid fa-chevron-down"></i></span>
                        <ul class="child">
                            <li *ngFor="let item of productCategory | slice:5:10"><a
                                    routerLink="/products/{{item?.pageUrl}}">{{item?.categoryName}} </a></li>
                        </ul>
                    </li>
                </ul>
            </div> -->
        </nav>
    </div>
    <app-login *ngIf="isLoginPopup" (close)="closeLoginPopup()" [loginPopuptype]="loginPopuptype"></app-login>
</div>